import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { Name, Email, Phone, Address } from "./ClientListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import { deleteVendor } from "../../../store/vendor/actions"
import {
  deleteClient,
  getClients,
  updateClient,
} from "../../../store/clients/actions"

function Clients() {
  const history = useHistory()
  const dispatch = useDispatch()

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [vendor, setVendor] = useState([])
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)

  const clients = useSelector(state => state.clients.clients)
  const total_page = useSelector(state => state.clients.total_page)
  const loading = useSelector(state => state.clients.loading)
  const [query, setQuery] = useState("")
  useEffect(() => {
    dispatch(getClients({ offset, page_size, query }))
  }, [dispatch, page_size, offset, query])

  useEffect(() => {
    if (!isEmpty(clients)) {
      setIsEdit(false)
    }
  }, [clients])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setVendor(null)
    } else {
      setModal(true)
    }
  }, [modal])

  const handleUserClick = useCallback(
    arg => {
      const vendor = arg
      history.push("/clients/add", vendor)
    },
    [history]
  )

  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (vendor.id) {
      dispatch(deleteClient(vendor))
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
      setModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    history.push("/clients/add")
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Image",
        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.image ? (
              <div className="avatar-md d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <>
                <img
                  className="avatar-md rounded-circle me-2"
                  src={imageBaseUrl + cellProps?.image}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return <Email {...cellProps} />
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        filterable: true,

        Cell: cellProps => {
          return <Phone {...cellProps} />
        },
      },
      {
        Header: "Address",
        accessor: "address",
        filterable: true,

        Cell: cellProps => {
          return <Address {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateClient({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateClient({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to={{
                      pathname: "/clients/edit",
                      state: cellProps.row.original,
                    }}
                    className="text-primary"
                    // onClick={() => {
                    //   // console.log(cellProps.row)
                    //   const clients =
                    //   handleUserClick(clients)
                    // }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const clients = cellProps.row.original
                      onClickDelete(clients)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/clients/events/${cellProps.row.original.id}`,
                            {
                              client_name:
                                cellProps.row.original.first_name +
                                cellProps.row.original.last_name,
                            }
                          )
                        }
                      >
                        Events
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/clients/purchases/${cellProps.row.original.id}`,
                            {
                              client_name:
                                cellProps.row.original.first_name +
                                cellProps.row.original.last_name,
                            }
                          )
                        }
                      >
                        Purchases
                      </DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick, loading]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Customers" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={clients}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={a => setOffset(a)}
                    _setPageSize={a => setPageSize(a)}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                    setQuery={setQuery}
                    query={query}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody></ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Clients.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Clients
